import { useMoveWorkflow } from "../hooks/useMoveWorkflow";
import { navigate, routes } from "../lib/urls";
import { MoveWorkflowModal } from "./MoveWorkflowModal";
import { SpaceSettings } from "./SpaceSettings";

export function CreateSpaceModal({
  workflowId,
  onClose,
}: {
  workflowId?: string;
  onClose: () => void;
}) {
  const {
    requestMove,
    pending: movePending,
    canMove,
    isLive,
    ready: moveReady,
    confirmMove,
    cancelMove,
  } = useMoveWorkflow();

  if (movePending) {
    if (!moveReady) return null;
    const closeMove = () => {
      cancelMove();
      onClose();
    };
    const move = () => {
      confirmMove();
      onClose();
    };
    return (
      <MoveWorkflowModal
        workflowId={movePending.workflowId}
        targetSpaceId={movePending.targetSpaceId}
        targetSpaceName={movePending.targetSpaceName}
        canMove={canMove}
        isLive={isLive}
        onClose={closeMove}
        onConfirm={move}
      />
    );
  }

  return (
    <SpaceSettings
      mode="create"
      onClose={onClose}
      onCreated={(spaceId, name) => {
        if (workflowId) {
          requestMove({
            workflowId,
            targetSpaceId: spaceId,
            targetSpaceName: name,
          });
          navigate(routes.space, { spaceId });
          return;
        }
        onClose();
        navigate(routes.space, { spaceId });
      }}
    />
  );
}
